import { ca } from '@cian/analytics';

import { TJsonQuery } from 'packages/JsonQuery';
import { mlSearchSession } from 'shared/mlSearchSession';

interface ITrackingParams {
  offerId: number;
  jsonQuery: TJsonQuery;
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №1
 */
export const trackClickOnBookedShowMoreButton = ({ offerId, jsonQuery }: ITrackingParams) => {
  const mlSearchSessionGuid = mlSearchSession.getSessionGuid(jsonQuery);

  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'booked_similar_offers',
    page: {
      extra: {
        mlSearchSessionGuid,
      },
    },
    products: [
      {
        id: offerId,
      },
    ],
  });
};

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №1
 */
export const trackShowBookedShowMoreButton = ({ offerId, jsonQuery }: ITrackingParams) => {
  const mlSearchSessionGuid = mlSearchSession.getSessionGuid(jsonQuery);

  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Listing',
    label: 'booked_similar_offers',
    page: {
      extra: {
        mlSearchSessionGuid,
      },
    },
    products: [
      {
        id: offerId,
      },
    ],
  });
};
